/**
 * Created by olga on 27.01.2025
 */

const KnockoutTutorial = function () {
    return new TutorialScenario("knockout", {
        priority: 1,
        listSteps: function () {
            return [KnockoutTutorial.createStep()];
        },
        isAvailable: function () {
            return Game.currentGame && !cleverapps.forces.isShown(Forces.KNOCKOUT_PLAYERS);
        }
    });
};

KnockoutTutorial.createStep = function () {
    const scene = cleverapps.Scenes.GetRunningScene();
    const playersView = cleverapps.Scenes.GetSceneComponent(GameSceneComponent).playersView;
    const wordGameComponent = typeof WordGameSceneComponent !== "undefined" && cleverapps.Scenes.GetSceneComponent(WordGameSceneComponent);
    const boardView = wordGameComponent && wordGameComponent.boardView;
    const options = {
        onStart: function () {
            cleverapps.focusManager.showControlsWhileFocused("players");
            playersView.runForceAnimation();
            this.force = cleverapps.forces.create(playersView, Forces.KNOCKOUT_PLAYERS, {
                highlights: [boardView && boardView.bgTop, scene.movingNode].filter(Boolean)
            });
            cleverapps.forces.onceForceClosed = function () {
                this.finish();
                Game.currentGame.counter.trigger();
            }.bind(this);
        },

        onFinish: function () {
            this.force.hideForceHints();
            playersView.stopForceAnimation();
        }
    };

    return new TutorialStep(options);
};
